import axios from "axios";


export const controlBoardsApi = axios.create({
    baseURL: `${process.env.VUE_APP_URL}/api/documents/control-boards`,
})